import React from 'react';
import { useNavigate } from 'react-router-dom';
import Finance from '../components/Finance/Finance';

const FinancePage = () => {
  const navigate = useNavigate();

  const setActiveSection = (section) => {
    if (section === 'policy') {
      navigate('/finance/policy');
    } else if (section === 'investment') {
      navigate('/finance/investment');
    } else {
      navigate(`/${section === 'home' ? '' : section}`);
    }
  };

  return <Finance setActiveSection={setActiveSection} />;
};

export default FinancePage;